import { Organisation } from '../../types/organization';
import { organizationApi } from '../api/organizationApi';
import { logger } from '../../utils/logger';

export class OrganisationService {
  static async getOrganisations(): Promise<Organisation[]> {
    try {
      return await organizationApi.listOrganisations();
    } catch (error) {
      logger.error('Failed to fetch organizations:', error);
      throw error;
    }
  }

  static async getClientOrganisation(clientId: string): Promise<Organisation[]> {
    try {
      return await organizationApi.clientOrganisations(clientId);
    } catch (error) {
      logger.error('Failed to fetch organizations:', error);
      throw error;
    }
  }
}
